var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',{staticClass:"section-about"},_vm._l((_vm.abouts),function(about,index){return _c('Faq',{key:`Definition : ${about.question}`,attrs:{"index":index,"definition":about}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }